/*************************** inizializzo firebase ********************* */

import { initializeApp } from "https://www.gstatic.com/firebasejs/10.7.1/firebase-app.js";
import { getDatabase, connectDatabaseEmulator } from "https://www.gstatic.com/firebasejs/10.7.1/firebase-database.js";
import { 
    getAuth, 
    connectAuthEmulator, 
    onAuthStateChanged, 
    signInWithEmailAndPassword,
    sendEmailVerification,
    signOut 
} from "https://www.gstatic.com/firebasejs/10.7.1/firebase-auth.js";

let db, auth;

// Funzione di bootstrap per caricare la config prima del resto dell'app
async function initFirebase() {
    try {
        // Chiediamo la configurazione corretta a Vercel (locale o produzione)
        const response = await fetch('/api/config.js');
        const config = await response.json();

        const app = initializeApp(config.firebaseConfig);
        db = getDatabase(app);
        auth = getAuth(app);

        // Se l'API ci dice che siamo in ambiente emulatore (locale)
        if (config.isEmulator) {
            connectDatabaseEmulator(db, "127.0.0.1", 9000);
            connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
            console.log("✅ Emulatori locali agganciati via API config!");
        }
    } catch (error) {
        console.error("Errore critico durante l'inizializzazione di Firebase:", error);
    }
}

// Inizializziamo subito
await initFirebase();

export { db, auth, onAuthStateChanged, signInWithEmailAndPassword, signOut };

/****************************************************************** */
//                        IMPORT GLOBALI
/****************************************************************** */

import { UIElement, vercelAsync, vercelAsyncOnAuth } from "./modules/module.js";
import * as ui from "./modules/uiFunctions.js";
import * as user from "./modules/uiUsers.js";
import * as r from "./modules/resource.js";
import * as tm from "./modules/theme-manager.js"
import { dragAndDrop } from "./modules/dd-manager.js";
import { LOG } from "./modules/customLog.js";


// Seleziona il contenitore che racchiude i bottoni
const divNascondi = document.getElementById("btn-nascondi");
const currentTheme = document.documentElement.getAttribute('data-bs-theme') || 'light';

const UI = {
  /** @type {UIElement} */  
  Overlay: new UIElement( 'loading-overlay'),
  /** @type {UIElement} */
  Login: new UIElement( 'login-signin'),
  /** @type {UIElement} */
  CP: new UIElement( 'modalsCP'),
  /** @type {UIElement} */
  ShowSection: new UIElement( null ), 
  /** @type {UIElement} */
  NewAtleta: new UIElement( 'div-atleta-form'),
  /** @type {UIElement} */
  BtnElimina: new UIElement( 'btn-elimina-atleta'),
  /** @type {UIElement} */
  ReadTable: new UIElement( 'storico'),
  /** @type {UIElement} */
  NewScheda: new UIElement( 'scheda-container'),
  /** @type {UIElement} */
  Coach: new UIElement( "dashnav"),
  /** @type {UIElement} */
  dashHome: new UIElement( "dash-home"),
  /** @type {UIElement} */
  nuovaGara: new UIElement( "nuova-gara"), 
  /** @type {UIElement} */
  storicoGare: new UIElement( "storico-gare"), 
  /** @type {UIElement} */
  subPanel: new UIElement( "sub-panel-assegnazione"),
  /** @type {UIElement} */
  editTemplate: new UIElement( "scheda-edit-template"), 
  /** @type {UIElement} */
  bozze: new UIElement( "scheda-gestione-bozze"),
  /** @type {UIElement} */
  User: new UIElement( "usersnav"),
  /** @type {UIElement} */
  Page404: new UIElement( "page404notfound"),
  /** @type {UIElement} */
  InfoPrivacy: new UIElement("infoPrivacy"),
  /** @type {UIElement} */
  ConsoleLog: new UIElement("console-log"),
};

const dashCoach = document.getElementById('dashnav')
const ELEM_pubIcon = document.getElementById('publisched-icon')

// elementi select atleta
const ELEM_Select = {
  selectAtleti : document.getElementById("select-atleti"),
  scheda : document.getElementById("scheda"),
  selectSettimana : document.getElementById("select-sett"),
  selectMobile: document.getElementById('select-atleti-mobile')
}
// elementi login
const ELEM_LOGIN = {
  form: document.getElementById("login-form"),
  submitBtn: document.getElementById("submit-btn"),
  emailInput: document.getElementById("email"),
  passwordInput: document.getElementById("password"),
  infoSpan: document.getElementById("response"),
  btnAggiornaPass: document.getElementById('aggiorna-password')
}
// elementi form scheda unificata
const ELEM_form = {
  formElem : document.getElementById("form-new-atleta"),
  btnSalvaAtleta : document.getElementById("salva-atleta"),
  h4Titolo:  document.getElementById("atleta-titolo"),
  sottotitolo: document.getElementById('atleta-sottotitolo'),
  btnAzioneAtleta: document.getElementById('btn-azione-atleta'),
  btnResetPassword: document.getElementById('btn-ripristina-pwd'),
  btnAnnulla: document.getElementById('btn-annulla-atleta'),
  btnElimina: document.getElementById('btn-elimina-atleta'),
  inputPwd: document.getElementById('pwd-new'),
}
// elementi dropdown logout/ light /dark mode
const ELEM_Dropdown = {
  divMenu: document.getElementById("dropdown-menu"),
  strongNome:  document.getElementById("nome-completo-coach"),
  imgCoach:  document.getElementById("img-coach")
}
// elementi scheda home
const ELEM_Dashhome = {
  spanNomeCoach: document.getElementById("span-nome-coach"),
  numAtleti: document.getElementById("numero-atleti-dashboard"),
  numGiorniNextGara: document.getElementById("numero-giorni-next-gara"),
  numeroGare: document.getElementById("numero-gare"),
}

// elementi toast
const TOAST_NODES = {
  toastLive: document.getElementById("liveToast"),
  smallToast: document.getElementById("small-toast"),
  testoToast: document.getElementById("testo-toast"),
}
//  elementi nuova scheda
const ELEM_Scheda = {
  divScheda: document.getElementById("container-scheda"),
  form: document.getElementById('form-new-scheda'),
  days: document.querySelectorAll('[data-num-day]'),
  switch: document.getElementById('switchBozzaPubblica'),
  labelSwitch: document.getElementById('label-switch-bozza'),
  btnWeek: document.querySelectorAll('[data-action-scheda="week"]'),
  titleScheda: document.getElementById('title-scheda'),
  subTitleScheda: document.getElementById('sub-title-scheda'),
  btnsalva: document.getElementById('btn-azione-scheda'),
  btnCronologia: document.querySelectorAll('.btn-cronologia'),
  btnLast: document.getElementById('nuova-scheda-carica-precedente'),
}
// elementi modale
const modalElement = document.getElementById('modalChoice');

const MODALE = {
    element: modalElement, // Riferimento al nodo DOM (per inert/aria-hidden)
    myModal: new bootstrap.Modal(modalElement), // Istanza di Bootstrap
    title: document.getElementById('modal-title'),
    message: document.getElementById('modal-message'),
    btnConfirm: document.getElementById('btn-confirm-modal')
};

const ELEM_Bozze = {
  spanNomeAtleta: document.getElementById('span-nome-atleta-bozze'),
  badgeBozze: document.getElementById('badge-bozze'),
  tbodyBozze: document.getElementById('tbody-bozze')
}
/**
 * Riferimenti al DOM di id relativi alla scheda storico.
 * @type {Object}
 */
const ELEM_storico = {
  tbodyStorico: document.getElementById('tbody-storico'),
  headerStorico: document.getElementById('header-scheda-storico'),
  btnPrev: document.getElementById('btn-prev-storico'),
  btnNext: document.getElementById('btn-next-storico'),
  divPrint: document.getElementById('printDiv')
}

/**
 * Riferimenti al DOM di id relativi alla scheda inserisci gare.
 * @type {Object}
 */
const ELEM_gare = {
  form: document.getElementById('form-new-gara'),
  btnAnnullaGara: document.getElementById('btn-annulla-gara'),
  btnSalvaGara: document.getElementById('btn-salva-gara'),
  divStoricoGare: document.getElementById('div-storico-gare'),
  tbodyGare: document.getElementById('table-storico-gare'),
  h4Titolo: document.getElementById('gara-titolo'),
}

/**
 * collection di HTML Element, sezione Edit Template.
 * @type {Object}
 */
const ELEM_EditTEMP = {
  div: document.getElementById('scheda-edit-template'),
  btnNewSection: document.getElementById('btn-nuova-sezione'),
  subPanelSection: document.getElementById('sub-panel-nuova-sezione'),
  btnSalvaSezione: document.getElementById('btn-salva-macro-sezione'),
  tableItemTempl: document.getElementById('table-item-template-allenamenti'),
  inputNomeSezione: document.getElementById('input-nome-sezione'),
  collapseArea: document.getElementById('collapse-area'),
}

const ELEM_Template = {
  accordionFrasi: document.getElementById('accordionFrasi')
}

// elementi ed inizializzazione TOOLTIPS
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

// Inizializza tutti i popover della pagina garantendo il funzionamento su mobile
const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))

/**
 * collection di HTML Element, sezione Edit Template.
 * @type {Object}
 */
const ELEM_User = {
  section: document.getElementById('usernav'),
  viewTab: document.getElementById('scheda-atleta-corrente'),
  currentTab: document.getElementById('div-atleta-scheda-corrente'),
  historyTab: document.getElementById('contenitore-giorni-storico'),
  selectStorico: document.getElementById('select-storico-settimane'),
}

const ELEM_first = {
  inputP: document.getElementById('checkPrivacy'),
  inputDS: document.getElementById('checkDatiSensibili'),
  stepForm: document.getElementById('step-form'),
  stepPrivacy: document.getElementById('step-privacy'),
  divTestoPrivacy: document.getElementById('testo-privacy-cookie'),
  containerTesto: document.getElementById('contenuto-privacy-modale')
}


/********************************************************************/
//                        INIZIO SEZIONE FUNZIONALE
/****************************************************************** */

/**
 * Segnaposto per assegnazione etichetta gold al button sidebar cliccato.
 * Viene aggiornato dinamicamente al click del button.
 * @type {HTMLElement}
 */
let ELEM_CLICKED_NOW = document.querySelector('[data-action="home-dashboard"]') 

/**
 * Segnaposto Globale che memorizza l'id dell'atleta selezionato.
 * Viene aggiornato dinamicamente al click delle option.
 * @type {string}
 */
let ATLETA_SELECT_INDEX = 0

/**
 * Contatore globale della settimana selezionata nell'applicazione.
 * Viene aggiornato dinamicamente durante la navigazione o l'editing.
 * @type {number}
 */
let NUM_WEEK = 0
/**
 * Contatore globale dell'anno selezionato nell'applicazione.
 * Viene aggiornato dinamicamente durante la navigazione o l'editing.
 * @type {number}
 */
let CURRENT_YEAR = 0

/**
 * Segnaposto per assegnazione colore al button cliccato.
 * Viene aggiornato dinamicamente al click del button.
 * @type {HTMLElement}
 */
let WEEK_ID = document.querySelector('#btn-week-1')

/**
 * @typedef {Object} GaraInfo
 * @property {string} name - Il nome dell'evento
 */

/**
 * @typedef {Object} LoginPayloadStructure
 * @property {string} linkcoach - ID utente (se presente)
 * @property {string} namecoach - Nome del coach/atleta
 * @property {string} nomecompletocoach - Contenitore dei dati delle gare
 * @property {Object.<string, GaraInfo>} race.lista -race.lista_date Dizionario delle gare indicizzate per ID
 * @property {Object.<string, Object.<string, boolean>>} race.lista_date - Mappa delle date con gli ID gara
 */

/**
 * Variabile globale per effettuare aggiornamenti frontend senza richiamare rtdb.
 * @type {LoginPayloadStructure|null}
 */
let LOGIN_PAYLOAD = null;

/**
 * Variabile globale per effettuare aggiornamenti frontend senza richiamare rtdb.
 * @type {Dati nodo race|null}
 */
let GARE_PAYLOAD = null;
/**
 * Variabile globale per effettuare aggiornamenti frontend senza richiamare rtdb.
 * @type {Dati nodo template|null}
 */
let TEMPLATE_PAYLOAD = null;
/**
 * Variabile globale per effettuare aggiornamenti frontend senza richiamare rtdb.
 * @type {Dati nodo user|null}
 */
let USER_PAYLOAD = null;
/**
 * Variabile globale utilizzata come flag.
 * @type {Dati accesso|null}
 */
let INFO = null;
/**
 * Variabile globale utilizzata come memoria temporanea.
 * @type {Dati accesso|null}
 */
let DASHHOME = null

// Variabili di STATO LOCALE per la navigazione dello storico
let storicoSettimaneArray = [];
let indiceSettimanaCorrente = 0;

// Inizializzazione listener accessibilità
ui.modalListener(MODALE)

// Se l'utente scrive, togliamo l'evidenziazione degli errori
ELEM_Scheda.form.addEventListener('input', () => {
  ELEM_Scheda.form.classList.remove('was-validated');
});

ELEM_Scheda.switch.addEventListener("change", (e)=>{
  if (e.target.checked) {
    ELEM_Scheda.labelSwitch.textContent =  "Salva e Pubblica"
    ELEM_Scheda.labelSwitch.classList.add('text-gold')
  } else {
    ELEM_Scheda.labelSwitch.textContent =  "Salva in Bozza"
    ELEM_Scheda.labelSwitch.classList.remove('text-gold')
  }
})

// Cattura qualsiasi errore non gestito nel sito
window.addEventListener('error', function(event) {
    console.error("Intercettato errore globale imprevisto:", event.error);
    UI.Page404.show()
});

// Cattura promesse fallite e non gestite (es. fetch fallite senza .catch)
window.addEventListener('unhandledrejection', function(event) {
    console.error("Promessa fallita non gestita:", event.reason);
    UI.Page404.show()
});

/********************************************************************/
//                        ONAUTHSTATECHANGE
/****************************************************************** */
/*
onAuthStateChanged(auth, async (user) => {
  UI.Overlay.show()
  try{
    if (user) {
      // UTENTE LOGGATO
      LOG.add( 'info', `🟢 Sessione attiva per: ${user.email}` )
      ELEM_LOGIN.form.reset()
      await login()
    } else {
      // UTENTE NON LOGGATO
      UI.Login.show()
      LOG.add( 'info', `🔴 Nessun utente loggato.` )
    }
  } catch (e) {
    UI.Login.show()
    console.log("Errore completo intercettato:", e); // Lo vedi in console se riesci ad accedervi
    await logOut(() => {
      // Mostriamo l'errore reale direttamente a schermo nella infoSpan!
      ELEM_LOGIN.infoSpan.textContent = `🚨 Errore: ${e.message || "Errore sconosciuto"}`;
      
      // Salviamo nel tuo sistema di log il messaggio di errore reale dell'eccezione
      LOG.add('error', `♨️ Errore Listener onAuthStateChange: ${e.message}`);
    })
  }
});

*/
onAuthStateChanged(auth, async (user) => {
  UI.Overlay.show()
  try {
    if (user) {
      // UTENTE LOGGATO
      LOG.add('info', `🟢 Sessione attiva per: ${user.email}`)
      ELEM_LOGIN.form.reset()
      await login()
    } else {
      // UTENTE NON LOGGATO
      UI.Login.show()
      LOG.add('info', `🔴 Nessun utente loggato.`)
    }
  } catch (e) {
    console.error("Errore completo intercettato:", e);
    
    // 1. Mostriamo subito l'errore a schermo sulla infoSpan (operazione immediata)
    ELEM_LOGIN.infoSpan.textContent = `🚨 Errore: ${e.message || "Errore sconosciuto"}`;
    UI.Login.show()
    
    // 2. Registriamo l'errore nel logger
    LOG.add('error', `♨️ Errore Listener onAuthStateChange: ${e.message || "Errore sconosciuto"}`);
    
    // 3. Eseguiamo il logout di pulizia in sicurezza senza passare callback annidate
    try {
      await logOut();
    } catch (logoutError) {
      console.error("Errore durante il recupero del logout:", logoutError);
    }
  } finally {
    // Questo garantisce al 100% che l'overlay scompaia, qualunque cosa accada sopra
    UI.Overlay.hide()
  }
});
/********************************************************************/
//                        SEZIONE LOGIN
/********************************************************************/

ELEM_LOGIN.submitBtn.addEventListener("click", async (e)=>{
  e.preventDefault()

  const email = ELEM_LOGIN.emailInput.value.trim();
  const password = ELEM_LOGIN.passwordInput.value.trim();

  // 1. Validazione rapida
  if (!email || !password) {
    ELEM_LOGIN.infoSpan.textContent = "Inserisci tutte le credenziali";
    return;
  }

  try{
    ui.loadButton( ELEM_LOGIN, true);
    // Autenticazione diretta col Client SDK
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    
    LOG.add( 'info', `Login successo: ${user.email}` )
    // Il reindirizzamento alla dashboard lo gestiamo in onAuthStateChanged
  }catch(error){
    console.error("Dettaglio errore:", error.code); // Per vederlo in console
    LOG.add( 'error', error.code )

    // Gestione messaggi "User Friendly"
    switch (error.code) {
      case 'auth/user-not-found':
          ELEM_LOGIN.infoSpan.textContent = "Utente non presente.";
          break;
      case 'auth/wrong-password':
          ELEM_LOGIN.infoSpan.textContent = "Password errata.";
          break;
      case 'auth/invalid-email':
          ELEM_LOGIN.infoSpan.textContent = "Formato email non valido.";
          break;
      case 'auth/invalid-credential':
          ELEM_LOGIN.infoSpan.textContent = "Credenziali non valide.";
          break;
      default:
          ELEM_LOGIN.infoSpan.textContent = "Errore durante l'accesso: " + error.message;
    }
  }finally{
    ui.loadButton( ELEM_LOGIN, false );
  }
})

async function login( ) {
  const { success, message, payload, sendEmail } = await loggedIn()
  ATLETA_SELECT_INDEX = 0

  if(success){
    if(message === "dashboard"){
      LOGIN_PAYLOAD = structuredClone(payload)
      dashboardCoach(LOGIN_PAYLOAD)
      UI.Login.hide()
      UI.User.hide()
      UI.Coach.show()
      UI.dashHome.show()
      await refreshTemplate()
      return true
    } else if(message === 'users'){
      USER_PAYLOAD = structuredClone(payload)
      console.log("userpayload", USER_PAYLOAD)
      await loadTabAtleta( ELEM_User , USER_PAYLOAD )
      UI.Login.hide()
      UI.dashHome.hide()
      UI.User.show()
    }else if( message === 'changePassword'){
      UI.Login.hide()
      UI.dashHome.hide()
      UI.User.hide()
      ELEM_LOGIN.btnAggiornaPass.setAttribute( 'data-temp', payload )
      const modal = new bootstrap.Modal('#modalPrimoAccesso'); 
      modal.show();
    }else {
      UI.Login.show()
      ELEM_LOGIN.infoSpan.textContent = message; 
      return false
    }
  }else{
    if (sendEmail) { 
      const currentUser = auth.currentUser; 

      if (currentUser) {
        try {
          // 1. Inviamo l'email nativa di Firebase sfruttando la sessione attiva
          await sendEmailVerification(currentUser); 
          ui.showModale(MODALE, "Nuovo Atleta", "Per motivi di sicurezza ti chiediamo di validare la tua email al link ricevuto.");
        } catch (mailError) {
          console.error("Errore invio email:", mailError.message);
        }
      }

      // 2. Applichiamo la filosofia del "buttafuori" per ripulire lo stato localmente
      await logOut(() => {
        UI.Login.show();
        ELEM_LOGIN.form.reset(); // Svuota i campi password vecchi
        ELEM_LOGIN.infoSpan.textContent = "Email in attesa di validazione";
      });

    }else{
      UI.Login.show()
      ELEM_LOGIN.infoSpan.textContent = message;
    }
  } 
}

async function loggedIn(dati) {
  try {
    return await vercelAsyncOnAuth(auth , "loggedInBackEnd", dati);
  } catch (er) {
    console.error("Errore nel recupero dati:", er);
  }finally{
    UI.Overlay.hide()
  }
}

async function logOut(callback = null) {
  try {
    await signOut(auth);
    localStorage.removeItem('user_data'); // Se avevi salvato qualcosa manualmente
    LOG.add( 'info', 'localStorage svuotato')
    console.log("⭕ Sessione chiusa correttamente nell'emulatore");
  } catch (error) {
    console.error("⚠️ Errore durante il logout:", error.message);
  }
  if (callback && typeof callback === "function") {
    callback(); 
  }
}

/****************************************************************************/
/*************************     DEBUG          ***************************** */
/*************************************************************************** */

document.getElementById('btn-debug-logo').addEventListener('click', ()=>{
  UI.dashHome.hide()

  const areaLog = document.getElementById('area-testo-log');

  function mostraLogNellaUI() {
      if (areaLog) {
          areaLog.textContent = LOG.ottieniFormatoTesto();
      }
  }

  document.getElementById('btn-refresh-log')?.addEventListener('click', mostraLogNellaUI);

  document.getElementById('btn-pulisci-log')?.addEventListener('click', () => {
      LOG.pulisci();
      mostraLogNellaUI();
  });

  UI.ConsoleLog.show()
})

/****************************************************************************/
/***********************   GESTIONE INFORMATIVA    **************************/
/****************************************************************************/

// Listener 1: Gestisce la prima checkbox (Privacy)
ELEM_first.inputP.addEventListener('change', (e) => {
    const isPrivacyChecked = e.target.checked;
    
    // Sblocca la seconda checkbox solo se la prima è spuntata
    ELEM_first.inputDS.disabled = !isPrivacyChecked;
    
    // Se l'utente toglie la spunta alla privacy, resettiamo e blocchiamo tutto a catena
    if (!isPrivacyChecked) {
        ELEM_first.inputDS.checked = false;
        setInputsDisabled(true);
    }
});

// Listener 2: Gestisce la seconda checkbox (Dati Sensibili)
ELEM_first.inputDS.addEventListener('change', (e) => {
    // Sblocca i campi password solo se ENTRAMBE le checkbox sono vere
    if (ELEM_first.inputP.checked && e.target.checked) {
        setInputsDisabled(false);
        console.log(false)
    } else {
        setInputsDisabled(true);
        console.log(true)
    }
    
});

// Funzione unica di supporto (pulita e senza problemi di scope)
function setInputsDisabled(shouldDisable) {
    const elements = document.querySelectorAll('.disabled-status');
    elements.forEach(element => {
        element.disabled = shouldDisable;
    });
}

document.getElementById('linkPrivacy').addEventListener('click', (e)=>{
  e.preventDefault()
  const html = ELEM_first.divTestoPrivacy.innerHTML + `<!-- Pulsante di uscita ottimizzato per Mobile -->
            <div class="d-grid gap-2 mt-5 mb-3 d-md-flex justify-content-md-end">
                <button id="indietro-privacy" type="button" class="btn btn-warning btn-lg px-4">
                    <i class="bi bi-arrow-left-short me-2"></i> Torna Indietro
                </button>
            </div>`
  ELEM_first.containerTesto.innerHTML = html

  const btn = document.querySelector('#indietro-privacy')
  if(!btn){
    ui.showModale(MODALE, "Attenzione", "Qualcosa è andato storto ricaricare e riprovare")
    return
  }

  ELEM_first.stepForm.classList.add('d-none')
  ELEM_first.stepPrivacy.classList.remove('d-none')

  btn.addEventListener('click', (e)=>{
      e.preventDefault()
        ELEM_first.stepForm.classList.remove('d-none')
        ELEM_first.stepPrivacy.classList.add('d-none')
        ELEM_first.containerTesto.innerHTML = ""
    })
})

document.getElementById('formPrimoAccesso').addEventListener('submit', async (e) => {
    e.preventDefault(); // Impedisce il ricaricamento della pagina

    const nuovaPassword = document.getElementById('nuovaPassword').value;
    const confermaPassword = document.getElementById('confermaPassword').value;
    const form = e.target;

    // 1. Controllo di corrispondenza delle password
    if (nuovaPassword !== confermaPassword) {
        document.getElementById('confermaPassword').setCustomValidity('Le password non coincidono.');
        form.classList.add('was-validated');
        return;
    } else {
        document.getElementById('confermaPassword').setCustomValidity('');
    }

    try {
      const newPayload = {
        userPayload: { 
          pwd: nuovaPassword,
          consensoPrivacy: ELEM_first.inputP.checked,
          consensoDatiSensibili: ELEM_first.inputDS.checked,
          }
        }  

      const { success, message } = await firstAccess( newPayload )

      if(success){
        const modalElement = document.getElementById('modalPrimoAccesso');
        const modalInstance = bootstrap.Modal.getInstance(modalElement);
        modalInstance.hide();
        form.reset();

        await logOut(() => {
            UI.Login.show();
            ELEM_LOGIN.infoSpan.textContent = message;
        });

      }else {
        // Se c'è un errore (es. dati incongruenti), qui sì che applichi il buttafuori
        await logOut(() => {
            UI.Login.show();
            ELEM_LOGIN.infoSpan.textContent = "";
            ui.showModale(MODALE, "Errore accesso", message);
        });
      }

    } catch (error) {
        // Sfrutta la tua gestione errori ottimizzata che legge il testo dal server
        UI.Login.show();
        ELEM_LOGIN.infoSpan.textContent = error.message;
        console.log(`Errore durante l'aggiornamento: ${error.message}`);
    }
});

document.getElementById('forza-logout').addEventListener('click', async (e)=>{
  e.preventDefault()
  await logOut(() => {
    const modalElement = document.getElementById('modalPrimoAccesso');
    const modalInstance = bootstrap.Modal.getInstance(modalElement);
    modalInstance.hide(); 
    UI.Login.show();
    ELEM_LOGIN.infoSpan.textContent = "";
    });
})

async function firstAccess(dati) {
  UI.Overlay.show()
  try {
    return await vercelAsyncOnAuth(auth , "gestionefirstAccessBE", dati);
  }finally{
    UI.Overlay.hide()
  }
}

/*************************************************************************/
/*************************   SEZIONE dashboard   *************************/
/*************************************************************************/

function dashboardCoach(payload){
  ui.updateDashHomeTitleInfo( ELEM_Dashhome, payload )
  ui.updateCoachDropdownInfo( ELEM_Dropdown, payload )
  ui.loadSelectAtleti(ELEM_Select.selectAtleti, payload)
  ui.loadSelectAtleti(ELEM_Select.selectMobile, payload)
}

/**************************************************************************/
/***********************  EVENT DELEGATION NAVBAR  ************************/
/**************************************************************************/

// EVENT DELEGATION BODY
document.body.addEventListener('click', async (e) => {
    const btn  = e.target.closest('.btn-closest');
    const link = e.target.closest('.a-closest');
    let action = null
    
    const elementoCliccato = btn || link;
    
    if (!elementoCliccato) return; 
    
    e.preventDefault();
    
    action = elementoCliccato.dataset.action;

    if( action !== "link-toggle-frasi"){
      if (ELEM_CLICKED_NOW !== elementoCliccato) {
        ui.switchActiveLabel( ELEM_CLICKED_NOW, elementoCliccato )
        ELEM_CLICKED_NOW = elementoCliccato;
      }
    }

    try{
      await handleAction(action)
    }catch(e){
      console.log(e)
    }

});

async function handleAction(action){
  if( action !== "home-dashboard"){
    UI.dashHome.hide()
  }  

  if (action) {
    UI.NewAtleta.hide()
    UI.ReadTable.hide() 
    UI.ConsoleLog.hide()
    UI.NewScheda.hide()
    UI.nuovaGara.hide()
    UI.editTemplate.hide()
    UI.bozze.hide() 
    
    if(action !== "gestisci-atleti-gara"){ UI.storicoGare.hide() }
      UI.subPanel.hide()

      switch(action){
        case "home-dashboard":
          ELEM_pubIcon.className = ''
          
          if(DASHHOME){
              if(!DASHHOME.set){
              const dashOld = document.getElementById('scheda-dashboard')
              dashOld.innerHTML = DASHHOME.html
            }
          }
            
          UI.dashHome.show()
          resetSelect()
          break;

        case "nuovo-atleta":
          ELEM_form.formElem.reset()
          setLayoutSchedaUnificata(ELEM_form, action)
          UI.NewAtleta.show()
          ELEM_form.btnResetPassword.hidden = true
          break;

        case "elimina-atleta":
          if( ATLETA_SELECT_INDEX != "0"){
            ELEM_form.formElem.reset()
            setLayoutSchedaUnificata(ELEM_form, action)
            preparaDatiPerEliminaAtleta()
            ELEM_form.btnResetPassword.hidden = false
          }else{
            ui.showCustomToast( TOAST_NODES, "🐔", "Seleziona prima un Atleta dall'Elenco", 3000 )
            UI.dashHome.show()
          }
          break;

        case "nuova-scheda":
          if( ATLETA_SELECT_INDEX != "0"){
            WEEK_ID = ui.cleanTextGoldWeek()
            NUM_WEEK = r.getWeekNumber(new Date())
            CURRENT_YEAR = new Date().getFullYear()
            ui.setScheda( ELEM_Scheda, NUM_WEEK, 'new')
            r.populateDays( ELEM_Scheda.days, r.impostaDateSettimana(NUM_WEEK))
            r.checkRace(  NUM_WEEK, LOGIN_PAYLOAD, ATLETA_SELECT_INDEX )
            UI.NewScheda.show()
          }else{
            ui.showCustomToast( TOAST_NODES, "🐔", "Seleziona prima un Atleta dall'Elenco", 3000 )
            UI.dashHome.show()
          }  
          break;
      
        case "scheda-pubblicata":
        case "storico-schede":
          if( ATLETA_SELECT_INDEX != "0"){
            const {success, message, payload} = await leggiScheda({
              idMascherato: ATLETA_SELECT_INDEX,
              action: action, 
            })
            
            if(success){
              inizializzaPaginazioneStorico(payload, ()=>{
                disabilitaPDF(LOGIN_PAYLOAD)
                UI.ReadTable.show()
              })
            }else{
              renderStoricoVuoto( ()=>{
              UI.ReadTable.show()
              } )
            }
          }else{
            ui.showCustomToast( TOAST_NODES, "🐔", "Seleziona prima un Atleta dall'Elenco" , 3000)
            UI.dashHome.show()
          }  
          break;
        
        case "inserisci-gara":
        // resetto il titolo il pulsante e il form nel caso di provenienza da modifica form   
          ELEM_gare.h4Titolo.innerHTML = `INSERISCI <span id="gara-titolo-span" class="text-gold">Gara</span>`
          ELEM_gare.btnSalvaGara.setAttribute('data-action-gare', "salva-gara") 
          ELEM_gare.form.reset()
          UI.nuovaGara.show() 
        break;

        case "storico-gare":
          UI.storicoGare.show()
          await storicoGare()
          break;

        case "gestisci-atleti-gara":
          UI.subPanel.show()  
          break;

        case "bozze-btn":
          if( ATLETA_SELECT_INDEX != "0"){          
            const res = await gestioneBozze({
              idMascherato: ATLETA_SELECT_INDEX,
              action: "get-bozza",
              numeroBozza: ""
            })
            if(res){
              ui.popolaBozze(ELEM_Bozze.tbodyBozze, ATLETA_SELECT_INDEX, res.payload, r.calcolaDateSettimana)
              UI.bozze.show()
            }
          }else{
            ui.showCustomToast( TOAST_NODES, "🐔", "Seleziona prima un Atleta dall'Elenco" )
            UI.dashHome.show()
          }  

        break;

        case "edit-template":
              ui.popolaEditTemplate( ELEM_EditTEMP, TEMPLATE_PAYLOAD, ()=>{
              UI.editTemplate.show()
            })
          break;

      }
  }
}

// EVENT DELEGATION DROPDOWNMENU
ELEM_Dropdown.divMenu.addEventListener("click", async (e)=>{
    const btn = e.target.closest('[data-action-dropdown]');
    
    if (!btn) {
      return;
    }else{
      e.preventDefault()
      let action =  btn.dataset.actionDropdown

      switch(action){
            case 'log-out':
              await logOut()
              break;

            case 'settings-coach':
              await coachSettings(()=>{
                settings()
                handleAction('home-dashboard')
                DASHHOME.set = false
              })
              break;
      }
    }
})

// EVENT DELEGATION NUOVO ATLETA
ELEM_form.formElem.addEventListener('click', async (e) => {
    
  // 1. Controlliamo se l'elemento cliccato è un bottone (o parte di esso)
    const btn = e.target.closest('[data-action-unificata]');

    if (!btn) return; // Se clicchi nel contenitore ma non su un bottone, esci.

    // 2. Recuperiamo l'azione dal data-attribute
    const action = btn.dataset.actionUnificata;

    // 3. Eseguiamo la logica in base al bottone
    e.preventDefault()
    e.stopPropagation()
    try {
        if (action) {
          switch(action){
            case "salva-atleta":  
              await setNewAtleta()
              break;

            case "annulla-atleta":  
              ELEM_form.formElem.reset()
              UI.NewAtleta.hide()
              UI.dashHome.show()
              resetSelect()
              break;

            case "elimina-atleta":
              await eliminaAtleta(ATLETA_SELECT_INDEX)
              break;

            case 'ripristina-pwd-atleta':
                await resetPwdAtleta( 'aleami2026!' )
              break;
          }
        }

    } catch (error) {
        console.error("Errore durante l'azione:", error.message);
    }
});

// EVENT DELEGATION NUOVA SCHEDA
ELEM_Scheda.divScheda.addEventListener('click', async (e)=>{
  const btn = e.target.closest('[data-action-scheda]');
  if (!btn) return; // Se clicchi nel contenitore ma non su un bottone, esci.
      // 2. Recuperiamo l'azione dal data-attribute
    const action = btn.dataset.actionScheda;

    // 3. Eseguiamo la logica in base al bottone
    e.preventDefault()
    e.stopPropagation()

    switch( action ){
      case 'annulla-scheda':
        annullaEchiudiScheda()
        return;
        
      case 'week':
        if (WEEK_ID !== btn) {
          ui.switchTextGold( WEEK_ID, btn )
          WEEK_ID = btn;
        }
        NUM_WEEK = parseInt(btn.value)
        r.populateDays( ELEM_Scheda.days, r.impostaDateSettimana(NUM_WEEK))
        r.getDateFromWeek()
        r.checkRace(  NUM_WEEK, LOGIN_PAYLOAD, ATLETA_SELECT_INDEX  )
        if( btn.dataset.edit != 0 ){
          ELEM_Scheda.btnLast.setAttribute('hidden', 'hidden')
          ELEM_Scheda.btnCronologia.forEach(elem =>{ elem.setAttribute('hidden', 'hidden')})
        }else { 
          ELEM_Scheda.btnLast.removeAttribute('hidden') 
          ELEM_Scheda.btnCronologia.forEach(elem =>{ elem.removeAttribute('hidden')})
        }
        return;

      case 'riposo':
        document.getElementById(btn.dataset.target).value = "RIPOSO"
        return;

      case 'salva-scheda':
        // 1. Il browser controlla se tutti i campi 'required' sono compilati
        if (!ELEM_Scheda.form.checkValidity()) {
          // Se qualcosa manca, aggiungiamo la classe che fa apparire gli errori
          ELEM_Scheda.form.classList.add('was-validated');
          ui.showCustomToast(TOAST_NODES, "⚠️", "Compila tutti i campi obbligatori!");
          return; // Fermiamo l'esecuzione qui
        }

        // 2. Se arriviamo qui, il form è valido al 100%
        const datiForm = ui.getInputFromForm(ELEM_Scheda.form);

        const time = new Date()
        const idScheda = `${time.getFullYear()}_${NUM_WEEK}`
        datiForm.settimana = idScheda
        datiForm.letto = false
        datiForm.coach = LOGIN_PAYLOAD?.nomeCompletoCoach


        const payload = {
          idMascherato: ATLETA_SELECT_INDEX,
          dati: datiForm,
          numBozze: "0000_00", 
          action: "bozze",
        }

        if( ELEM_Scheda.switch.checked){
          payload.action = "programma_corrente"
          payload.numBozze = idScheda
        }

        await nuovaScheda(payload)
        return;

      case 'carica-settimana-precedente':
        const btnId = btn.dataset.btn
        const ref = document.getElementById(btnId)
        if(!ref) return

        await caricaSchedaPrecedente({
              idMascherato: ATLETA_SELECT_INDEX,
              action: 'read-last',
              numWeek: ref.value
            })
        return;
    }
})

function annullaEchiudiScheda(){
  ELEM_Scheda.form.reset()
  if(DASHHOME){
    if(!DASHHOME.set){
    const dashOld = document.getElementById('scheda-dashboard')
    dashOld.innerHTML = DASHHOME.html
    }
  }
  UI.NewScheda.hide()
  UI.dashHome.show()
}

//  CHECKBOX PRESA VISIONE
document.addEventListener('change', function(e) {
    // Se l'utente clicca sul checkbox della presa visione
    if (e.target && e.target.id === 'switchCheck-presa-visione') {
        const btnEliminaReal = document.getElementById(ELEM_form.btnElimina.id);
        
        if (e.target.checked) {
            ELEM_form.btnElimina.innerText = "Elimina"
            btnEliminaReal.disabled = false;
            ELEM_form.btnResetPassword.hidden = true
        } else {
            ELEM_form.btnElimina.innerText = "Prendi visione"
            btnEliminaReal.disabled = true;
            ELEM_form.btnResetPassword.hidden = false
        }
    }
});

//  BOZZE
ELEM_Bozze.tbodyBozze.addEventListener('click', async (e)=>{
  const btn = e.target.closest('[data-action-bozza]');
  if (!btn) return; 

  e.preventDefault()
  e.stopPropagation()

  const actionSel = btn.dataset.actionBozza;     
  const idBozza = btn.dataset.bozza;       
  const idMascherato = btn.dataset.atleta;

  UI.Overlay.show();

  try {
    // 3. Spediamo il pacchetto completo all'API unificata su Vercel
    const { success, message, payload } = await gestioneBozze({
      numeroBozza: idBozza,
      idMascherato: idMascherato,
      action: actionSel
    });

    if (success) {
      // CASO EDITA: Se l'azione era edita, passiamo il payload (la scheda) alla tua funzione
      if (actionSel === "edita-bozza") {
        ui.populateForm(ELEM_Scheda.form, payload, ()=>{
          const { anno, numWeek } = r.extractWAY( payload.settimana )
          UI.bozze.hide()
          ui.setScheda(ELEM_Scheda, numWeek, 'edit')
          r.populateDays( ELEM_Scheda.days, r.impostaDateSettimana(numWeek, anno))
          NUM_WEEK = numWeek
          UI.NewScheda.show()
        })
        
        return; // Usciamo perché non dobbiamo cancellare la riga dalla tabella
      }

      // CASO ELIMINA O PUBBLICA: In entrambi i casi la bozza sparisce da questo elenco
      ui.eliminaTRdaTabella(ELEM_Bozze, idBozza); 
      ui.aggiornaOption(actionSel, ATLETA_SELECT_INDEX, (res)=>{
        if(!res) return 
        const { numBozze, pubbl } = res
        aggiornaBadgeBozzaPubblicazione(numBozze, pubbl)
      })

      if (ELEM_Bozze.tbodyBozze.rows.length === 0) {
        // Richiami la funzione passandogli un oggetto vuoto per mostrare il messaggio "Nessuna bozza"
        ui.popolaBozze(ELEM_Bozze.tbodyBozze, "", {}); 
      }
      
      ui.showCustomToast(TOAST_NODES, "Gestione Bozze", message);
    } else {
      // Gestione errore logico restituito dal backend
      ui.showModale(MODALE, "Attenzione", message);
    }
  } catch (err) {
    console.error("Errore di rete o nel listener:", err);
  } finally {
    UI.Overlay.hide();
  }
});

/****************************************************************************/
/*************************     settings              ********************** */
/************************************************************************** */

function settings(){
  const select_modalita = document.getElementById('setting-sfondo')
  const btnInvio = document.getElementById('btn-salva-settings')
  
  setBadgeTheme() 

  select_modalita.addEventListener('change', (e)=>{
    const action = e.target.value
    tm.setAndSaveGlobalTheme(action)
    setBadgeTheme()
  })

  btnInvio.addEventListener('click', async (e)=>{
    e.preventDefault()
    const input_limite = document.getElementById('setting-limite-storico')
    const select_pdf = document.getElementById('setting-stato-app')

    const userPayload = {};

    // Aggiungi al payload solo se l'utente ha effettivamente inserito o selezionato qualcosa
    if (input_limite.value !== "") {
        userPayload.limiteStorico = Number(input_limite.value); // Convertilo anche in numero per sicurezza
    }

    if (select_pdf.value !== "") {
        userPayload.abilitaPdf = select_pdf.value;
    }

    const dataPayload = {
        action: 'set-new', 
        userPayload: userPayload
    };

    const { success, message, payload} = await gestioneSettings( dataPayload ) 

    if( success){
      const { limiteStorico, abilitaPdf } = payload
      let string = ""

      string += (limiteStorico !== undefined && limiteStorico !== null) 
          ? `Limite storico a ${limiteStorico === 0 ? "nessun limite" : limiteStorico} ` 
          : "";

      string += abilitaPdf ? `Abilita pdf a ${abilitaPdf} ` : ""

      ui.showModale(MODALE, "Settings", `${message}. aggiornati i seguenti elementi: ${string}`)
    }else{
      ui.showModale(MODALE, "Settings", message)
    }

    handleAction('home-dashboard')
    DASHHOME.set = false

  })


  // funzione riservata
  function setBadgeTheme(){
    const theme = localStorage.getItem('theme') || "default"
    document.getElementById('badge-sfondo').textContent = theme
    select_modalita.value = theme
  }
}

async function coachSettings( callback = null ){
  const dashOld = document.getElementById('scheda-dashboard')
  if(!dashOld){ 
    LOG.add('error', 'codice html dashboard errore getElementById')
    return 
  }

  const { success, message, payload } = await gestioneSettings( {action: 'show', userPayload: ""} )
  if( success){
    DASHHOME = {html: dashOld.innerHTML, set: true}
    dashOld.innerHTML = payload    
  }else{
    ui.showModale(MODALE, "Settings", message)
    LOG.add('error', message)
  }

  // Sostituisci la chiamata diretta con questa:
  if (callback && typeof callback === "function") {
    setTimeout(callback, 0); // Sposta la callback alla fine della coda dei task, dopo il rendering del DOM
  }
}

async function gestioneSettings(dati) {
  UI.Overlay.show()
  try {
    return await vercelAsyncOnAuth(auth , "gestioneSettingsBE", dati);
  } catch (er) {
    console.error("Errore nel recupero dati:", er);
    return { 
      success: false, 
      message: "Errore di connessione durante il recupero dei settings." 
    };
  }finally{
    UI.Overlay.hide()
  }
}

/**
 * Abilita o disabilita il pulsante di esportazione dello storico in base allo stato dei PDF.
 * @param {Object|null|undefined} payload - L'oggetto contenente le impostazioni del coach
 * @param {string} [payload.abilita_pdf] - Lo stato di abilitazione del PDF (es. 'sospesa')
 */
function disabilitaPDF(payload){
  const set = payload?.abilita_pdf === 'sospesa'
  const btn = document.getElementById('btn-esporta-storico');
  if (btn) {
    btn.disabled = set;
  }
}
/************************************************************* */
/************************  SELECT  *************************** */
/************************************************************* */

//  SELECT ATLETI
ELEM_Select.selectAtleti.addEventListener("change", (e)=>{
  listenerSelect(e)
  ELEM_Select.selectMobile.value = e.target.value
})

ELEM_Select.selectMobile.addEventListener("change", (e)=>{
  listenerSelect(e)
  ELEM_Select.selectAtleti.value = e.target.value
})

function listenerSelect(e){
  ATLETA_SELECT_INDEX = e.target.options[e.target.selectedIndex].value
  let num = parseInt(e.target.options[e.target.selectedIndex].dataset.bzz)
  let pub = e.target.options[e.target.selectedIndex].dataset.pbh

  aggiornaBadgeBozzaPubblicazione(num, pub)

  annullaEchiudiScheda()
  UI.storicoGare.hide()
  UI.ReadTable.hide()
  UI.NewAtleta.hide()
  UI.ReadTable.hide() 
  UI.NewScheda.hide()
  UI.nuovaGara.hide()
  UI.editTemplate.hide()
  UI.bozze.hide() 
}

function aggiornaBadgeBozzaPubblicazione(numeroBozze, pubblicatoSioNo){
  ELEM_Bozze.badgeBozze.textContent = numeroBozze > 0 ? numeroBozze : ""
  ELEM_pubIcon.className = pubblicatoSioNo === "true" ? 'text-gold bi bi-pin-angle ms-2' : '';
}
/****************************************************************************/
/*************************     GESTIONE GARE  ***************************** */
/************************************************************************** */

//  gestione gare inserisci gare
ELEM_gare.form.addEventListener('click', async (e)=>{
  const btn = e.target.closest('[data-action-gare]');
  if (!btn) return; // Se clicchi nel contenitore ma non su un bottone, esci.
  
  
  e.preventDefault()
  e.stopPropagation()

  const action = btn.dataset.actionGare;

  ELEM_gare.form.classList.remove('was-validated');
  
  if( action === "annulla-gara"){      
    ELEM_gare.form.reset()
    UI.nuovaGara.hide()
    UI.dashHome.show()
  }else if( action === "salva-gara" ){
    // 1. Il browser controlla se tutti i campi 'required' sono compilati
    if(!ELEM_gare.form.checkValidity()) {
      // Se qualcosa manca, aggiungiamo la classe che fa apparire gli errori
      ELEM_gare.form.classList.add('was-validated');
      ui.showCustomToast(TOAST_NODES, "⚠️", "Compila tutti i campi obbligatori!");
      return; // Fermiamo l'esecuzione qui
    }

    // 2. Se arriviamo qui, il form è valido al 100%
    const datiForm = ui.getInputFromForm(ELEM_gare.form);  

    const { success, message, payload } = await gestioneGare( { userPayload: datiForm, action: 'new-race'} )

    if( success ){
      const { id, name, date } = payload
      ui.showCustomToast(TOAST_NODES, "Nuova Gara", message)
      UI.nuovaGara.hide()

    // 1. Inizializza i nodi se sono vuoti (evita crash se è la prima gara in assoluto)
      LOGIN_PAYLOAD.race = LOGIN_PAYLOAD.race || {};
      LOGIN_PAYLOAD.race.lista = LOGIN_PAYLOAD.race.lista || {};
      LOGIN_PAYLOAD.race.lista_date = LOGIN_PAYLOAD.race.lista_date || {};
      
      // 2. Aggiorna la lista delle gare
      LOGIN_PAYLOAD.race.lista[id] = { data: date };
      
      // 3. Aggiorna la lista delle date (Usa le quadre [id] per renderla dinamica!)
      // Inizializza la data se non esiste già un'altra gara quel giorno
      LOGIN_PAYLOAD.race.lista_date[date] = LOGIN_PAYLOAD.race.lista_date[date] || {};
      LOGIN_PAYLOAD.race.lista_date[date][id] = true;

      ui.updateDashHomeTitleInfo( ELEM_Dashhome, LOGIN_PAYLOAD)
      UI.dashHome.show()
      ELEM_gare.form.reset()
    }else{
      ui.showModale( MODALE, "Errore", message)
    }
  }else if( action === "modifica-gara" ){
    // 1. Il browser controlla se tutti i campi 'required' sono compilati
    if(!ELEM_gare.form.checkValidity()) {
      // Se qualcosa manca, aggiungiamo la classe che fa apparire gli errori
      ELEM_gare.form.classList.add('was-validated');
      ui.showCustomToast(TOAST_NODES, "⚠️", "Compila tutti i campi obbligatori!");
      return; // Fermiamo l'esecuzione qui
    }

    // 2. Se arriviamo qui, il form è valido al 100%
    const datiForm = ui.getInputFromForm(ELEM_gare.form);  
    datiForm.raceId = btn.dataset.raceid

    const { success, message, payload } = await gestioneGare( { userPayload: datiForm, action: 'update-race'} )

    if( success ){
      const { id, name, date } = payload
      ui.showCustomToast(TOAST_NODES, "Gestione Gara", message)
      UI.nuovaGara.hide()

    // 1. Inizializza i nodi se sono vuoti (evita crash se è la prima gara in assoluto)
      LOGIN_PAYLOAD.race ??=  {};
      LOGIN_PAYLOAD.race.lista ??= {};
      LOGIN_PAYLOAD.race.lista_date ??= {};
      // 2. Aggiorna la lista delle gare
      LOGIN_PAYLOAD.race.lista[id] = { name: name };
      
      // 3. Aggiorna la lista delle date (Usa le quadre [id] per renderla dinamica!)
      // Inizializza la data se non esiste già un'altra gara quel giorno
      LOGIN_PAYLOAD.race.lista_date[date] = LOGIN_PAYLOAD.race.lista_date[date] || {};
      LOGIN_PAYLOAD.race.lista_date[date][id] = true;

      ui.updateDashHomeTitleInfo( ELEM_Dashhome, LOGIN_PAYLOAD)
      UI.dashHome.show()
      ELEM_gare.form.reset()
      ELEM_gare.btnSalvaGara.removeAttribute('data-raceid')
    }else{
      ui.showModale( MODALE, "Errore", message)
    }
  }

})

// gestione gare Storico
ELEM_gare.divStoricoGare.addEventListener('click', async (e)=>{
  const btn = e.target.closest('[data-action-elenco-gare]');
  if (!btn) return; // Se clicchi nel contenitore ma non su un bottone, esci.
  
  e.preventDefault()
  e.stopPropagation()

  const action = btn.dataset.actionElencoGare;
  
  switch( action ){
    case 'gestisci-atleti-gara':
      ui.subPanelEditaGara( btn, LOGIN_PAYLOAD, GARE_PAYLOAD , (dati)=>{
        ui.badgeAtletiIscritti(dati)
      })  
      break;

    case 'chiudi-sub':
      ui.chiudiGestioneAtletiGara()
      break;

    case 'modifica-gara':
      await modificaGara( btn )
      break;

    case 'elimina-gara':
      await eliminaGara( btn )  
      break;

    case 'assegna-gara':
      await assegnaGara( btn )
      break;

    case "rimuovi-atleta-gara":
      await rimuoviAtletaGara( btn )  
      break;

  }
})

async function modificaGara(btn){

  const raceId =  btn.dataset.raceid
  const dateId =  btn.dataset.dateid
  const trTable = btn.dataset.tr

  if(GARE_PAYLOAD[raceId]){
    UI.storicoGare.hide()
    const temp = {
      nome_evento: GARE_PAYLOAD[raceId].dati.nomeEvento,
      data_evento: GARE_PAYLOAD[raceId].dati.dataEvento,
      localita_evento: GARE_PAYLOAD[raceId].dati.localitaEvento,
      link_evento: GARE_PAYLOAD[raceId].dati.linkEvento,
    }
    Object.entries(GARE_PAYLOAD[raceId].dati.distanze).forEach(([key,value])=>{
      document.querySelector(`[name="${key}"]`).checked = true
    })
    ui.populateForm( ELEM_gare.form, temp, ()=>{
      ELEM_gare.h4Titolo.innerHTML = `MODIFICA <span id="gara-titolo-span" class="text-gold">Gara</span>`
      ELEM_gare.btnSalvaGara.setAttribute('data-action-gare', "modifica-gara")
      ELEM_gare.btnSalvaGara.setAttribute('data-raceid',  raceId )
      UI.nuovaGara.show()
    })
    
  }
}

async function eliminaGara(btn){
  const eliminaPayload = {
    raceId: btn.dataset.raceid,
    dateId: btn.dataset.dateid,
    trTable: btn.dataset.tr
  }

  const { success, message, payload } = await gestioneGare( { action: 'delete-race',  userPayload: eliminaPayload } )

  if( success ){
    const { raceId, atletiRimossi, trTable } = payload;

    if (GARE_PAYLOAD[raceId]) {
      delete GARE_PAYLOAD[raceId];
    }

    if(Object.keys(GARE_PAYLOAD).length === 0){
      ui.popolaTabellaElencoGare( ELEM_gare, GARE_PAYLOAD)
    }else{
      ui.chiudiGestioneAtletiGara()
      document.getElementById(trTable).remove()
    }
    ui.showCustomToast( TOAST_NODES, "Gestione Gare", `L'evento "${message}" è stato rimosso correttamente.\nEvento rimosso per ${atletiRimossi.length} atleti.`,3000 )
  }else{
    ui.showModale(MODALE, "Storico Gare", message)
  }
}

async function rimuoviAtletaGara( btn ){
  const rimuoviAtletaPayload = {
    raceId: btn.dataset.raceid,
    atleta: btn.dataset.atletaUid
  }

  const { success, message, payload } = await gestioneGare( { action: 'remove-athlete', userPayload: rimuoviAtletaPayload } )

  if( success ){
    const { raceId, atleta } = payload;

    delete GARE_PAYLOAD[raceId]?.iscritti[atleta];
    delete LOGIN_PAYLOAD?.race?.lista?.[raceId]?.iscritti?.[atleta];

    ui.badgeAtletiIscritti( { iscritti: GARE_PAYLOAD[raceId].iscritti, raceId: raceId }, (res)=>{
      if(res){
        aggiornaNumeroAtletiBadge(raceId)
        ui.showCustomToast(TOAST_NODES, "Gestione Gare", message, 2000)
      }else{
        ui.showModale(MODALE, "Gestione Gare", "Attenzione qualcosa è andato storto, ricaricare la pagina e riprovare.")
      }
    })
  }else{
    ui.showModale(MODALE, "Storico Gare", message)
  }
}

async function assegnaGara( btn ){
  const optionAtleta = document.getElementById('select-atleta-gara')
  const optionDistanza = document.getElementById('select-distanza-atleta')
  const atletaUid = optionAtleta.options[optionAtleta.selectedIndex].value
  const nomeAtleta = optionAtleta.options[optionAtleta.selectedIndex].textContent
  const distanza = optionDistanza.options[optionDistanza.selectedIndex].value
  
  if( atletaUid === "default" ){
    ui.showCustomToast( TOAST_NODES, "Gare", "Seleziona un atleta dall'elenco", 3000)
    return
  }
  if( distanza === "default" ){
    ui.showCustomToast( TOAST_NODES, "Gare", "Seleziona una distanza dall'elenco", 3000)
    return
  }

  const assegnaPayload = {
    raceId: btn.dataset.raceid,
    atleta: atletaUid ,
    distance: distanza,
    nome: nomeAtleta
  }

  const { success, message, payload } = await gestioneGare( { action: 'assegna-gara', userPayload: assegnaPayload } );

  if( success ){
    optionAtleta.selectedIndex = 0;
    optionDistanza.selectedIndex = 0;
    const { raceId, atleta, distance, nome } = payload;

    // 1. Se iscritti non era ancora presente, inizializza il suo sotto-oggetto
    GARE_PAYLOAD[raceId].iscritti ??= {};

    // 2. Se questo specifico atleta non era ancora presente, inizializza il suo sotto-oggetto
    GARE_PAYLOAD[raceId].iscritti[atleta] ??= {};

    // 3. Ora puoi fare l'assegnazione in totale sicurezza!
    GARE_PAYLOAD[raceId].iscritti[atleta][nome] = distance 
    // aggiorno la sezione iscritti della lista del coach 
    LOGIN_PAYLOAD.race.lista[raceId].iscritti ??= {};
    LOGIN_PAYLOAD.race.lista[raceId].iscritti[atleta] = distance;

    ui.badgeAtletiIscritti( { iscritti: GARE_PAYLOAD[raceId].iscritti, raceId: raceId }, (res)=>{
      if(res){
        aggiornaNumeroAtletiBadge(raceId)
        ui.showCustomToast(TOAST_NODES, "Gestione Gare", message, 2000)
      }else{
        ui.showModale(MODALE, "Gestione Gare", "Attenzione qualcosa è andato storto, ricaricare la pagina e riprovare.")
      }
    })
  }else{
    ui.showModale(MODALE, "Gestione Gare", message)
  }
}

async function storicoGare(){
  const { success, message, payload } = await gestioneGare( {action: 'read'} )
  if( success ){
    GARE_PAYLOAD = structuredClone(payload)
    UI.storicoGare.show()
    ui.popolaTabellaElencoGare( ELEM_gare, GARE_PAYLOAD, ()=>{
      UI.storicoGare.show()
    })
  }else{
    ui.showModale(MODALE, "Storico Gare", message)
  }
}

//  FUNZIONE PONTE FRONTEND BACKEND GARE
async function gestioneGare(dati) {
  UI.Overlay.show()
  try {
    const response = await vercelAsyncOnAuth(auth , "gestioneGareBE", dati);
    return response
  } catch (er) {
    console.error("Errore nel recupero dati:", er);
  }finally{
    UI.Overlay.hide()
  }
}

function aggiornaNumeroAtletiBadge(raceId){
  document.getElementById(`numero-iscritti-${raceId}`).textContent = `${Object.keys(GARE_PAYLOAD[raceId]?.iscritti).length} Atleti`
}

document.getElementById('cat-custom-attivo').addEventListener('change', (e) => {
  const isChecked = e.target.checked;
  const inputKm = document.getElementById('cat-custom-km');
  
  inputKm.disabled = !isChecked;
  if (!isChecked) {
    inputKm.value = '';
  }
});

document.getElementById('cat-custom2-attivo').addEventListener('change', (e) => {
  const isChecked = e.target.checked;
  const inputKm = document.getElementById('cat-custom2-km');
  
  inputKm.disabled = !isChecked;
  if (!isChecked) {
    inputKm.value = '';
  }
});

/****************************************************************************/
/*************************     EDIT TEMPLATE         ********************** */
/************************************************************************** */

//  EDIT TEMPLATE
ELEM_EditTEMP.div.addEventListener('click', async (e)=>{
  const btn = e.target.closest('[data-action-template]');
  if (!btn) return; // Se clicchi nel contenitore ma non su un bottone, esci.
  
  
  e.preventDefault()
  e.stopPropagation()

  const action = btn.dataset.actionTemplate;

  if( action != "conferma-aggiornamento-eliminati" && action != "pre-elimina" ){ delete TEMPLATE_PAYLOAD.tempItem }

  switch( action ){

    // pulsante NUOVA SEZIONE 
    case "nuova-sezione":
      openCloseSubSection(ELEM_EditTEMP, 'open')
      break;

    // Pulsante per chiudere il pannello aggiungi sezione
    case "chiudi-sub-sezione":
      openCloseSubSection(ELEM_EditTEMP, 'close')
      break;

    // pulsante che aggiunge la sezione al database
    case "salva-sezione":
      await saveSection(ELEM_EditTEMP, btn, ()=> refreshTemplate(false))
    break;

    // Click su "+ Item" (Mostra Inserimento, Nasconde Eliminazione)
    case "add-item": { 
      document.getElementById(`vista-eliminazione-${btn.dataset.index}`).classList.add('d-none');
      document.getElementById(`vista-aggiungi-${btn.dataset.index}`).classList.remove('d-none');

      const panelElement = document.getElementById(btn.dataset.target);
      if (panelElement) {
        bootstrap.Collapse.getOrCreateInstance(panelElement).show();
      }
      document.getElementById(btn.dataset.ref).focus()
      break;
    }

    // Click sul Badge Giallo (Mostra Eliminazione, Nasconde Inserimento)
    case "item-sezione": { 
      preparaElementiDaEliminare(btn.dataset.sezione)
      ui.popolaItemDaEliminare( btn.dataset.sezione, TEMPLATE_PAYLOAD[btn.dataset.sezione], btn.dataset.index, ()=>{
        document.getElementById(`vista-aggiungi-${btn.dataset.index}`).classList.add('d-none');
        document.getElementById(`vista-eliminazione-${btn.dataset.index}`).classList.remove('d-none');

        const panelElement = document.getElementById(btn.dataset.target);
        if (panelElement) {
          bootstrap.Collapse.getOrCreateInstance(panelElement).show();
        }
      })
      break;
    }

    // pulsante "Salva" item inserito in input
    case "new-item":
      await newItem( ELEM_EditTEMP, btn, ()=> refreshTemplate(false))
      break;
    
    // Click su "Update" sezione
    case "rinomina-sezione": 
      updateSection( ELEM_EditTEMP, btn )
      break;

    // Click su "Elimina" sezione
    case "elimina-sezione":
      await deleteSection( btn, ()=> refreshTemplate(false)  ) 
      break;

    case "pre-elimina":
      preElimina(btn) 
      break;

    case "conferma-aggiornamento-eliminati":
      dashCoach.classList.remove('pe-none');
      await eliminaItem( btn, ()=>{
        aggiornaBadge( btn.dataset.ref , TEMPLATE_PAYLOAD[btn.dataset.section] )
        collapseCustom(document.getElementById(btn.dataset.ref))
        return refreshTemplate(false)
      })
      break;

    case "chiudi-elimina-item":
      dashCoach.classList.remove('pe-none');
      preparaElementiDaEliminare(btn.dataset.section, true)
      aggiornaBadge( btn.dataset.ref , TEMPLATE_PAYLOAD[btn.dataset.section] )
      break;


  } // fine switch
})

/**
 * Gestisce l'area di "staging" temporanea per la cancellazione o la modifica di elementi
 * all'interno di una specifica sezione del template (es. 'macro_fasi', 'esercizi').
 * Crea una copia speculare e isolata dell'array originale in `TEMPLATE_PAYLOAD.tempItem[sectionName]`.
 * * Se l'utente annulla l'operazione, i dati ufficiali rimangono protetti; se conferma, 
 * le modifiche verranno applicate definitivamente.
 *
 * @param {string} sectionName - Il nome della proprietà/sezione dentro `TEMPLATE_PAYLOAD` da clonare (es. 'macro_fasi').
 * @param {boolean} [update=false] - Di default è `false`. Se impostato su `true`, forza la sovrascrittura dell'area temporanea aggiornandola con lo stato attuale dell'array ufficiale (utile dopo un inserimento o un drag-and-drop).
 * @returns {void} Non ritorna alcun valore, muta direttamente l'oggetto globale `TEMPLATE_PAYLOAD`.
 * * @example
 * // 1. Prima di aprire la modalità modifica/eliminazione (Inizializzazione):
 * preparaElementiDaEliminare('macro_fasi'); // Crea la copia speculare solo se non esiste già
 * * @example
 * // 2. Dopo che l'interfaccia ha subito un riordinamento (Forza l'allineamento dello staging):
 * preparaElementiDaEliminare('macro_fasi', true); // Sovrascrive il temporaneo con i nuovi dati ordinati
 */
function preparaElementiDaEliminare(sectionName, update = false) {
  if (!TEMPLATE_PAYLOAD.tempItem) {
    TEMPLATE_PAYLOAD.tempItem = {}; 
  }

  // 🚀 Ottimizzazione: uniamo i due controlli che fanno la stessa cosa
  // Se la copia temporanea non esiste ANCORA, oppure se abbiamo chiesto esplicitamente un 'update'
  if (!TEMPLATE_PAYLOAD.tempItem[sectionName] || update) { 
    // 🎯 Shallow clone dell'array usando lo spread operator [...] per isolare i riferimenti
    TEMPLATE_PAYLOAD.tempItem[sectionName] = [...TEMPLATE_PAYLOAD[sectionName]]; 
  }
}

function preElimina(btn){
  const posIndex = Number(btn.dataset.position);
  const sectionName = btn.dataset.section 
  const containerIndex = btn.dataset.containerIndex
  let ref = "input_" + containerIndex

  dashCoach.classList.add('pe-none');
  document.getElementById(`vista-eliminazione-${containerIndex}`).classList.add('pe-auto');
  document.getElementById(`span-item-${posIndex}`).remove()

  let eliminati = TEMPLATE_PAYLOAD.tempItem[sectionName].splice(posIndex, 1, null )

  let arrayFittizzioPerCalcoloLunghezza = TEMPLATE_PAYLOAD.tempItem[sectionName].filter( x => x != null)

  aggiornaBadge( ref, arrayFittizzioPerCalcoloLunghezza, true )
}

async function eliminaItem(btn, callback = null){
  const sectionName = btn.dataset.section

  const newArrayItem = TEMPLATE_PAYLOAD.tempItem[sectionName].filter( item => item != null )

  const userPayloadObj = {
    action: btn.dataset.action,
    userPayload: { section: sectionName, newItems: newArrayItem }
  }

  const { success, payload, message } = await trainingTemplate( userPayloadObj )

  if( success ){
    ui.showCustomToast(TOAST_NODES, sectionName, message, 3000)
    delete TEMPLATE_PAYLOAD.tempItem
    TEMPLATE_PAYLOAD[sectionName] = payload
  }else{
    ui.showModale( MODALE, "Errore", message)
  }

  if (callback && typeof callback === "function") callback();
}

function openCloseSubSection(elemDom, action){
  const { subPanelSection, tableItemTempl, inputNomeSezione, btnSalvaSezione } = elemDom
  btnSalvaSezione.dataset.action = 'create'

  const obj = {
    open: function (){
      subPanelSection.removeAttribute("hidden")
      tableItemTempl.setAttribute("inert", true)
      inputNomeSezione.focus()
    },
    close: function (){
      subPanelSection.setAttribute("hidden", true)
      tableItemTempl.removeAttribute("inert")
      inputNomeSezione.value = ""
    }
  }
  obj[action]()
}

async function saveSection(elemDom, btn, callback = null){
  const { subPanelSection, tableItemTempl, inputNomeSezione } = elemDom

  let input = inputNomeSezione.value
  if( input === ""){
    ui.showCustomToast(TOAST_NODES, "Sezione", "Inserisci un nome valido per la sezione.", 3000)
    return
  }

  const setAction = btn.dataset.action

  const userPayloadObj = {
    action: setAction,
    userPayload: { section: input }
  }

  if( setAction === 'update'){
    userPayloadObj.userPayload.oldKey = btn.dataset.oldValue
  }

  const { success, payload, message } = await trainingTemplate( userPayloadObj )

  if( success ){
    if( setAction === 'update'){
      TEMPLATE_PAYLOAD[payload.section] = payload.itemData
      delete TEMPLATE_PAYLOAD[payload.oldSection]
    }else{
      TEMPLATE_PAYLOAD[input] = [ true ]
    }
    
    ui.popolaEditTemplate( ELEM_EditTEMP, TEMPLATE_PAYLOAD, ()=>{ 
      let title = payload ? "Item" : "Sezione"
      ui.showCustomToast(TOAST_NODES, title , message, 3000)
      subPanelSection.setAttribute("hidden", true)
      tableItemTempl.removeAttribute("inert")
      inputNomeSezione.value = ""
    })
  }else{
    ui.showModale( MODALE, "Errore", message)
  }

  if (callback && typeof callback === "function") callback();
}

async function newItem(elemDom, btn, callback = null){
  let input = document.getElementById(btn.dataset.ref)
  let datoInserito = input.value.trim();
  let sectionName = input.dataset.sectionName
  let ref = btn.dataset.ref

  let posIndex = TEMPLATE_PAYLOAD[sectionName].length - 1

  const { success, message, payload } = await trainingTemplate({
    action: 'create',
    userPayload: { section: sectionName, newItem: datoInserito, lastIndex: posIndex}
  })

  if( success ){
    ui.showCustomToast(TOAST_NODES, sectionName, "Nuovo elemento creato con successo.", 3000)
    input.value = ""

    const { section, item } = payload

    TEMPLATE_PAYLOAD[section].push(item)

    aggiornaBadge( ref, TEMPLATE_PAYLOAD[section] )
    collapseCustom(input)
  }else{
    ui.showModale( MODALE, "Inserimento elemnto Sezione", message)
  }

  if (callback && typeof callback === "function") callback();
}

function aggiornaBadge( ref, dataLength , temp = false){
  let element = document.querySelector(`[data-update="${ref}"]`)

  if(temp){
    element.classList.remove("text-bg-warning")
    element.classList.add('text-bg-danger')
  }else{
    element.classList.remove("text-bg-danger")
    element.classList.add('text-bg-warning')
  }

  if (element) {
    const numeroItemVisibili = dataLength.length
    element.textContent = `${numeroItemVisibili - 1} item`;
  }
}

async function deleteSection( btn, callback = null ){
  const sectionName = btn.dataset.sezione
  const tr = btn.dataset.tr

  if( sectionName ){
    const { success, message, payload } = await trainingTemplate({
      action: 'delete',
      userPayload: { section: sectionName }
    })

    if( success ){
      document.querySelector(`#${tr}`).remove()
      delete TEMPLATE_PAYLOAD[sectionName];
      ui.showCustomToast(TOAST_NODES, "Sezione",  message, 3000)
    }else{
      ui.showCustomToast( TOAST_NODES, "Sezione", "Attenzione sezione non selezionata, ricaricare la pagina e riprovare.")
    }
  }
  if (callback && typeof callback === "function") callback();
}

function updateSection(elemDom, btn){
  const { inputNomeSezione, btnSalvaSezione } = elemDom
  const oldSection = btn.dataset.sezione
  inputNomeSezione.value = oldSection
  openCloseSubSection(elemDom, 'open')
  btnSalvaSezione.dataset.action = 'update'
  btnSalvaSezione.dataset.oldValue = oldSection
}

function collapseCustom(input, action = 'hide'){
  const panelId = input.dataset.target; // Prende "panel-sezione_1"
  const panelElement = document.getElementById(panelId);

  if (panelElement) {
    // Recuperiamo l'istanza di Bootstrap associata a quel DIV o la creiamo al volo
    const collapseInstance = bootstrap.Collapse.getOrCreateInstance(panelElement);
    
    if (typeof collapseInstance[action] === 'function') {
      collapseInstance[action]();
    } else {
      console.warn(`L'azione "${action}" non è un metodo valido di Bootstrap Collapse.`);
    }
  }
}

/**
 * Aggiorna l'interfaccia grafica dei template di allenamento (Accordion).
 * Permette di scegliere se rinfrescare i dati leggendoli dal Database 
 * o se fare un rendering rapido sfruttando la copia locale in memoria.
 *
 * @async
 * @param {boolean} [readDB=true] - Di default è impostato su `true`. Se `true` (o omesso), effettua una chiamata al DB per scaricare i dati e aggiornare la cache locale. Se impostato a `false`, salta la chiamata al DB e renderizza l'interfaccia istantaneamente usando i dati locali esistenti.
 * @returns {Promise<void>} Non ritorna alcun valore, aggiorna direttamente il DOM dell'interfaccia.
 * * @example
 * // 1. Al Login (Caricamento iniziale pesante dal DB - sfrutta il default):
 * await refreshTemplate(); // Va al DB, scarica i dati e popola TEMPLATE_PAYLOAD
 * * @example
 * // 2. Dopo la creazione di un nuovo elemento (Rendering istantaneo da cache locale):
 * await newItem(ELEM_EditTEMP, btn, () => refreshTemplate(false)); // Salta il DB, velocissimo
 */
async function refreshTemplate(readDB = true) {
  if (readDB) {
    const { success, message, payload } = await trainingTemplate({ action: 'read' });
    if (success) {
      // Aggiorna la cache locale con una copia profonda per evitare mutazioni impreviste
      TEMPLATE_PAYLOAD = structuredClone(payload);
      
      ui.popolaAccordionTemplate(ELEM_Template.accordionFrasi, TEMPLATE_PAYLOAD, () => {
        dragAndDrop();
      });
    }
  } else {
    // Sfrutta la cache locale 'TEMPLATE_PAYLOAD' già popolata in precedenza
    ui.popolaAccordionTemplate(ELEM_Template.accordionFrasi, TEMPLATE_PAYLOAD, () => {
      dragAndDrop();
    });
  }
}



ELEM_storico.divPrint.addEventListener('click', async (e)=>{
  const btn = e.target.closest('[data-action-nav]');
  if (!btn) return; // Se clicchi nel contenitore ma non su un bottone, esci.
  
  e.preventDefault()
  e.stopPropagation()

  const action = btn.dataset.actionNav;
  
  switch( action){
    case 'prev':
      if (indiceSettimanaCorrente > 0) {
        indiceSettimanaCorrente--;
        renderizzaSettimanaStorico();
      }
      break;
    
    case 'next':
      if (indiceSettimanaCorrente < storicoSettimaneArray.length - 1) {
        indiceSettimanaCorrente++;
        renderizzaSettimanaStorico();
      }
      break;

    case 'pdf':
      generaHtmlPdf()
      break;
  }
})

/*********************************************************/
/*****               NUOVO ATLETA             ************/
/*********************************************************/

// SALVATAGGIO IN DB NUOVO ATLETA
async function setNewAtleta() { 
  UI.Overlay.show('Iscrizione Nuovo Atleta')

  const dati = ui.getInputFromForm( ELEM_form.formElem )

  try {
    const response = await vercelAsyncOnAuth(auth , "setNewAtletaBackEnd", dati);
    
    if(response.success){
      const res = await login()
      if(res){
        ui.showCustomToast( TOAST_NODES, "✅", response.message )
        LOG.add('errore', `"✅  ${response.message}`)
      }
    }else{
      ui.showCustomToast( TOAST_NODES, "⚠️ Errore", response.message )
      LOG.add('errore', `"⚠️ Errore ${response.message}`)
    }

    ELEM_form.formElem.reset()
    UI.NewAtleta.hide()
    UI.dashHome.show()

  } catch (er) {
    console.error("Errore nel recupero dati:", er);
    ui.showModale(MODALE, "⚠️ Errore", `Errore nel recupero dati: ${er}`)
    LOG.add('info', `"Errore nel recupero dati: ${er}`)
  }finally{
    UI.Overlay.hide()
  }
}

//  ELIMINA ATLETA, MOSTRO DATI PRECARICATI
async function preparaDatiPerEliminaAtleta(){
  const eliminaPayload = {
    action: "anagrafica-atleta" ,
    userPayload:{ idMascherato: ATLETA_SELECT_INDEX}
  }

  const { success, message, payload } = await gestioneAtleta( eliminaPayload )

  if(success){
    ui.populateForm(ELEM_form.formElem, payload )
    ui.toggleForm(ELEM_form.formElem, true)
    UI.NewAtleta.show()
  }else{
    ui.showModale(MODALE, "Attenzione", message)
    LOG.add('errore', `"⚠️ Attenzione ${message}`)
    UI.NewAtleta.hide()
    UI.dashHome.show()
  }
}

//  ELIMINAZIONE EFFETTIVA 
async function eliminaAtleta(dati) {
  const eliminaPayload = {
    action: "delete-atleta" ,
    userPayload:{ idMascherato: ATLETA_SELECT_INDEX}
  }

  const { success, message, payload } = await gestioneAtleta( eliminaPayload )

  if(success){
    const res = await login()
    if(res){
      ui.showModale(MODALE, "Atleta Rimosso", "Tutti i dati relativi all'atleta sono stati Eliminati dal DataBase")
      LOG.add('info', `Tutti i dati relativi all'atleta sono stati Eliminati dal DataBase`)
      UI.NewAtleta.hide()
    }else{
      ui.showModale(MODALE, "Attenzione", message)
      LOG.add('info', `Attenzione ${message}`)
    }

    ui.toggleForm(ELEM_form.formElem, false)
    ELEM_form.formElem.reset()
  }
}

//  RIPRISTINO PASSWORD ATLETA 
async function resetPwdAtleta(dati) {
  const ripristinaPayload = {
    action: "ripristino-atleta" ,
    userPayload:{ idMascherato: ATLETA_SELECT_INDEX, nuovaPassword: dati }
  }

  try{
    const { success, message, payload } = await gestioneAtleta( ripristinaPayload )

    if(success){
        ELEM_form.formElem.reset()
        ui.showModale(MODALE, "Ripristino Password", message)
        LOG.add('info', `Ripristino Password: ${message}`)
        UI.NewAtleta.hide()
        UI.dashHome.show()
        resetSelect(
          
        )
      }else{
        ui.showModale(MODALE, "Attenzione", message)
        LOG.add('info', `Attenzione ${message}`)
      }
    }catch(error){
      ui.showModale(MODALE, error.message)
    }
}

async function nuovaScheda(dati) {
  UI.Overlay.show()
  try {
    const { success, message, payload } = await vercelAsyncOnAuth(auth , "gestioneTAB_BE", dati);
    
    if(success){
      await login()
      resetSelect()
      ui.showCustomToast(TOAST_NODES, "✅", "Operazione completata con successo!");
      LOG.add('info', `nuova scheda creata ${message}`)
      UI.NewScheda.hide()
      ELEM_Scheda.form.reset()
    }else{
      ui.showModale(MODALE, "Scheda", message);
      LOG.add('info', `nuova scheda:  ${message}`)
    }
  } catch (er) {
    console.error("Errore nel recupero dati:", er);
  }finally{
    UI.Overlay.hide()
  }
}

async function caricaSchedaPrecedente(dati){
  UI.Overlay.show()
  try {
    const { success, message, payload } = await vercelAsyncOnAuth(auth , "gestioneTAB_BE", dati);
    
    if(success){
      ui.showCustomToast(TOAST_NODES, "✅", "scheda precedente recuperata!");
      LOG.add('info', `scheda precedente recuperata`)
      ui.popolaUltimaScheda( payload )
    }else{
      ui.showCustomToast(TOAST_NODES, "X", "scheda precedente non presente!");
      LOG.add('info', `scheda precedente non presente!`)
    }
  } catch (er) {
    console.error("Errore nel recupero dati:", er);
  }finally{
    UI.Overlay.hide()
  }
}

async function gestioneAtleta(dati) {
  UI.Overlay.show()
  try {
    return await vercelAsyncOnAuth(auth , "gestioneAtletaBE", dati);
  } catch (er) {
    console.error("Errore nel recupero dati:", er);
  }finally{
    UI.Overlay.hide()
  }
}

async function leggiScheda(dati) {
  UI.Overlay.show()
  try {
    return await vercelAsyncOnAuth(auth , "gestioneTAB_BE", dati);
  } catch (er) {
    console.error("Errore nel recupero dati:", er);
  }finally{
    UI.Overlay.hide()
  }
}

async function trainingTemplate(dati) {
  UI.Overlay.show()
  try {
    return await vercelAsyncOnAuth(auth , "gestioneTemplateBE", dati);
  } catch (er) {
    console.error("Errore nel recupero dati:", er);
    return { success: false, message: er.message }
  }finally{
    UI.Overlay.hide()
  }
}

async function gestioneBozze(dati) {
  UI.Overlay.show()
  try {
    return await vercelAsyncOnAuth(auth , "gestioneBozzeBE", dati);
  } catch (er) {
    console.error("Errore nel recupero dati:", er);
    return { 
      success: false, 
      message: "Errore di connessione con il server. Riprova tra poco." 
    };
  }finally{
    UI.Overlay.hide()
  }
}

/*********************************************************
****                Funzioni di Utility
 *********************************************************/

function renderStoricoVuoto( callback = null ){
  ELEM_storico.headerStorico.textContent = ""
    ELEM_storico.tbodyStorico.innerHTML = `
      <tr id="row-nessuna-scheda">
          <td colspan="7" class="text-center py-5 text-secondary">
              <div class="d-flex flex-column align-items-center gap-3">
                  <i class="bi bi-calendar-x opacity-50" style="font-size: 3rem;"></i>
                  <div>
                      <h6 class="fw-semibold text-body mb-1">Nessuna scheda.</h6>
                      <p class="small text-muted mb-0">Non ci sono schede inserite nello storico.</p>
                  </div>
                  <button data-action="nuova-scheda" type="button" class="btn btn-sm btn-gold mt-1 btn-closest" >
                      <i class="bi bi-plus-circle me-1"></i> Aggiungi un scheda
                  </button>
              </div>
          </td>
      </tr>`;
      
    if (callback && typeof callback === "function") callback();
    return;
}
/**
 * Funzione di PRECARICA: Ordina lo storico solo se necessario e mostra la prima scheda.
 */
function inizializzaPaginazioneStorico(datiFirebase, callback = null) {
  if (!datiFirebase || Object.keys(datiFirebase).length === 0 ){
    ui.showModale(MODALE, "Storico Gare", "Qualcosa è andato storto nel recupero dati, aggiorna e riprova.")
    return
  } 

  // 1. Trasformiamo l'oggetto in un Array [ [key, value], [key, value] ]
  const entries = Object.entries(datiFirebase); 

  // 2. 🔥 ORDINAMENTO: Lo eseguiamo solo se ci sono più schede nello storico
  if (entries.length > 1) {
    storicoSettimaneArray = entries.sort(([keyA], [keyB]) => {
      const [annoA, weekA] = keyA.split('_').map(Number);
      const [annoB, weekB] = keyB.split('_').map(Number);

      if (annoA !== annoB) {
        return annoB - annoA; // Ordina per anno (es. 2025 prima del 2026)
      }
      return weekB - weekA; // A parità di anno, ordina per settimana (es. 2 prima di 12)
    });
  } else {
    // Se c'è una sola settimana, la assegniamo direttamente senza perdere tempo a ordinarla
    storicoSettimaneArray = entries;
  }

  // 3. Partiamo dall'inizio (indice 0)
  indiceSettimanaCorrente = 0;

  // 4. Mostriamo la scheda a schermo
  renderizzaSettimanaStorico();

  if (callback && typeof callback === "function") {callback()}
}

/**
 * Funzione di CONTROLLER: Gestisce il rendering e l'attivazione/disattivazione dei pulsanti
 */
function renderizzaSettimanaStorico() {
  const totaleSchede = storicoSettimaneArray.length;
  const [key, value] = storicoSettimaneArray[indiceSettimanaCorrente];

  // 1. Lanciamo la funzione di interfaccia passando SOLO la settimana corrente
  ui.popolaStorico(ELEM_storico, key, value, r.calcolaDateSettimana);

  if (ELEM_storico.btnPrev && ELEM_storico.btnNext) {
    ELEM_storico.btnPrev.disabled = (indiceSettimanaCorrente === 0);
    ELEM_storico.btnNext.disabled = (indiceSettimanaCorrente === totaleSchede - 1);

    
    // Aggiorniamo i testi dei bottoni con il conteggio (es. Next (2/5))
    ELEM_storico.btnPrev.innerHTML = `<i class="bi bi-arrow-left-square me-2"></i>Prev<span class="badge bg-secondary ms-2">${indiceSettimanaCorrente}</span> 
                                        `;
    ELEM_storico.btnNext.innerHTML = `<i class="bi bi-arrow-right-square me-2"></i>Next<span class="badge bg-secondary ms-2">${totaleSchede - (indiceSettimanaCorrente + 1)}</span>`;
  }
}

function resetSelect(){
  ELEM_Bozze.badgeBozze.textContent = ""
  ELEM_Select.selectAtleti.selectedIndex = 0;
  ATLETA_SELECT_INDEX = 0;
  ELEM_pubIcon.className = ''
}

function setLayoutSchedaUnificata({h4Titolo, sottotitolo, btnAzioneAtleta}, select){
  const { title, subtitle , btnText, showElimina } = ui.editTemplate(select)

  showElimina ? UI.BtnElimina.show() : UI.BtnElimina.hide()
  !showElimina ? UI.ShowSection.showByName(btnAzioneAtleta.id): UI.ShowSection.hideByName(btnAzioneAtleta.id)

  h4Titolo.innerHTML = title
  sottotitolo.innerHTML = subtitle
  btnAzioneAtleta.innerText = btnText
}

function getAllenamentiBySezione(sezioneKey) {
    const sezione = databaseSnapshotMock[sezioneKey];
    if (!sezione) return null;
    return Object.values(sezione)[0] || null;
}

// Funzione 2: Pura logica di formattazione per la UI
function formattaListaModale(oggettoLista) {
    if (!oggettoLista || Object.keys(oggettoLista).length === 0) {
        return "Nessun elemento presente";
    }
    return Object.keys(oggettoLista)
        .map((key, index) => `${index}: ${oggettoLista[key]}`)
        .join('\n');
}

/****************************************************************************************** */
/*                                       USERS                                              */
/****************************************************************************************** */

const switchTema = document.getElementById('switch-tema-dark');
const iconaTema = document.getElementById('icona-tema');
const testoTema = document.getElementById('testo-tema');

// 1. Controlla se c'è una preferenza salvata, altrimenti usa quella del sistema operativo
const temaSalvato = localStorage.getItem('theme') || (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');

// 2. Applica il tema all'avvio
applicaTema(temaSalvato);

// 3. Ascolta il click sullo switch
switchTema.addEventListener('change', () => {
    const nuovoTema = switchTema.checked ? 'dark' : 'light';
    applicaTema(nuovoTema);
});

function applicaTema(tema) {
    // Applica l'attributo al tag HTML globale (influenza tutta l'app)
    document.documentElement.setAttribute('data-bs-theme', tema);
    
    // Salva la scelta
    localStorage.setItem('theme', tema);

    // Aggiorna lo stato dello switch e la grafica
    if (tema === 'dark') {
        switchTema.checked = true;
        testoTema.textContent = "Tema Scuro";
        iconaTema.className = "bi bi-moon-stars-fill me-1 text-warning"; // Luna gialla in dark mode
    } else {
        switchTema.checked = false;
        testoTema.textContent = "Tema Chiaro";
        iconaTema.className = "bi bi-sun-fill me-1 text-secondary"; // Sole grigio in light mode
    }
}

let view = null

document.addEventListener('click', async (e)=>{
  const btn = e.target.closest('.user-closest a');
  if (!btn) return; 
  
  e.preventDefault()
  e.stopPropagation()
  
  const action = btn.dataset.actionUser;
  
  

  switch(action){
    case 'atleta-scheda-corrente': 
      UI.ShowSection.hideByName('scheda-atleta-storico')
      UI.ShowSection.hideByName('scheda-info')
      await loadTabAtleta( ELEM_User , USER_PAYLOAD )
      view = null
      break;

    case 'atleta-storico':
      UI.ShowSection.hideByName('scheda-atleta-corrente')
      UI.ShowSection.hideByName('scheda-info')
      await loadHistoryUser( ELEM_User )
      view = "history"
      break;

    case 'atleta-logout':
      await logOut(()=>{
        UI.ShowSection.hideByName('scheda-atleta-corrente')
        UI.ShowSection.hideByName('scheda-info')
        UI.User.hide()
      })
      break;

    case 'atleta-pdf':
      generaHtmlPdf()  
      break;

    case 'atleta-info':
      UI.ShowSection.hideByName('scheda-atleta-corrente')
      UI.ShowSection.hideByName('scheda-atleta-storico')
      UI.ShowSection.showByName('scheda-info')
      break;
  }
})

async function loadTabAtleta( ELEM_User , USER_PAYLOAD ){
  if(!USER_PAYLOAD.abilitaPdf){
    document.querySelectorAll('[data-action-user="atleta-pdf"]').forEach( elem => {
      elem.inert = true
      elem.hidden = true})
  }else{
    document.querySelectorAll('[data-action-user="atleta-pdf"]').forEach( elem => {
      elem.inert = false
      elem.hidden = false
    })
  }
  
  user.popolaSchedaUser( ELEM_User , USER_PAYLOAD , async (e)=>{
    UI.ShowSection.showByName('scheda-atleta-corrente')
    if(e){
      const { success, message, payload } = await gestioneUserTab( { action: 'set-flag', userPayload: true} )
      console.log( message, payload )
    }
  })
}

async function loadHistoryUser( ELEM_User ){
  const { success, message, payload } = await gestioneUserTab( { action: 'load-history', userPayload: true} )
  if( success ){
      user.popolaHistorySelect( ELEM_User , payload , (e)=>{
        UI.ShowSection.showByName('scheda-atleta-storico')
        ELEM_User.selectStorico.addEventListener('change', (e)=>{
          user.popolaHistoryUser( ELEM_User, payload[e.target.value], ()=>{
            UI.ShowSection.showByName('scheda-atleta-storico')
          })
        })
    })
  }
}

//  FUNZIONE PONTE FRONTEND BACKEND USER
async function gestioneUserTab(dati) {
  UI.Overlay.show()
  try {
    return await vercelAsyncOnAuth(auth , "gestioneUserTabBE", dati);
  } catch (er) {
    console.error("Errore nel recupero dati:", er);
  }finally{
    UI.Overlay.hide()
  }
}

function estraiDatiSorgente() {
    const dati = {
        nomeCompletoAtleta: "Atleta",
        header: "",
        nomeCoach: "",
        tbodyHTML: ""
    };

    const giorni = ["lunedi", "martedi", "mercoledi", "giovedi", "venerdi", "sabato", "domenica"];

    // --- 1. AUTO-DETECTION DI LAYOUT E CONTESTO ---
    
    // Controlliamo se la tabella desktop è presente E visibile sullo schermo (non nascosta da d-none)
    const tbodySchermo = document.querySelector('#tbody-storico');
    const isDesktopVisible = tbodySchermo && (tbodySchermo.offsetWidth > 0 || tbodySchermo.offsetHeight > 0);
    const isMobile = !isDesktopVisible;

    // Capiamo se siamo nello Storico (History) controllando se esistono ed elementi storici visibili
    let type = "";
    if (isMobile) {
        const moduliStorico = document.querySelectorAll('.pdf-module-hist');
        // Se esistono elementi "-hist" e sono visibili a schermo
        const isHistoryVisible = moduliStorico.length > 0 && Array.from(moduliStorico).some(el => el.offsetWidth > 0);
        if (isHistoryVisible) {
            type = "history";
        }
    }

    console.log(`🔍 PDF Auto-Detect: Layout=${isMobile ? 'Mobile' : 'Desktop'} | Tipo=${type || 'Standard'}`);

    // --- 2. RECUPERO NOME ATLETA ---
    if (isMobile) {
        const opzioneAtleta = document.querySelector(".pdf-name");
        dati.nomeCompletoAtleta = opzioneAtleta ? opzioneAtleta.textContent : "Atleta";
    } else {
        const opzioneAtleta = document.querySelector(`option[value="${ATLETA_SELECT_INDEX}"]`);
        dati.nomeCompletoAtleta = opzioneAtleta ? opzioneAtleta.text : "Atleta";
    }

    // --- 3. RECUPERO HEADER SCHEDA ---
    if (isMobile) {
        if (type === "history") {
            const week = document.querySelector('[data-info-week]')?.dataset.infoWeek;
            const year = document.querySelector('[data-info-year]')?.dataset.infoYear;
            const temp_array = typeof r !== 'undefined' 
                ? r.calcolaDateSettimana(Number(week), Number(year)) 
                : calcolaDateSettimana(Number(week), Number(year));
            dati.header = `SCHEDA STORICO DAL ${temp_array[0]} AL ${temp_array[6]}`;
        } else {
            const pdfHeader = document.querySelector('.pdf-header');
            dati.header = pdfHeader ? pdfHeader.textContent : "Scheda Allenamento";
        }
    } else {
        const headerElement = document.getElementById('header-scheda-storico');
        if (headerElement) {
            dati.header = headerElement.innerText.split(')')[0] + ')';
        }
    }

    // --- 4. RECUPERO COACH ---
    const coachElement = document.querySelector('[data-info]');
    if (coachElement) {
        dati.nomeCoach = coachElement.dataset.info;
    } else if (!isMobile) {
        dati.nomeCoach = LOGIN_PAYLOAD?.nomeCompletoCoach || "";
    }

    // --- 5. COSTRUZIONE TABELLA (TBODY) ---
    if (isMobile) {
        const classe = type === "history" ? "-hist" : "";
        const moduleDay = document.querySelectorAll(`.pdf-module${classe}`);
        const arrayDate = document.querySelectorAll(`.pdf-date${classe}`);

        if (moduleDay.length > 0) {
            let html = "";
            moduleDay.forEach((module, index) => {
                html += `<tr>
                    ${index < 7 ? `<td style="padding: 10px; border: 1px solid #dddddd;">${giorni[index]}</td>` : ""} 
                    ${index < 7 ? `<td style="padding: 10px; text-align: center; border: 1px solid #dddddd;">${arrayDate[index]?.textContent || ''}</td>` : ""}
                    ${index > 6 ? `<td style="padding: 10px; border: 1px solid #dddddd;"><strong>NOTE del Coach:</strong></td><td style="border: 1px solid #dddddd;"></td>` : ""} 
                    <td colspan="1" style="padding: 10px; border: 1px solid #dddddd; color: #000000;">${module.textContent}</td>
                </tr>`;
            });
            dati.tbodyHTML = html;
        } else {
            dati.tbodyHTML = '<tr><td colspan="3" style="padding: 10px; text-align: center; color: #000000;">Nessun esercizio presente</td></tr>';
        }
    } else {
        if (tbodySchermo) {
            const tempTbody = document.createElement('tbody');
            tempTbody.innerHTML = tbodySchermo.innerHTML;

            const righe = tempTbody.querySelectorAll('tr');
            const celle = tempTbody.querySelectorAll('td, th');

            righe.forEach(riga => {
                riga.className = ''; 
                riga.style.borderBottom = '1px solid #dddddd';
            });

            celle.forEach(cella => {
                cella.className = ''; 
                cella.style.padding = '10px';
                cella.style.backgroundColor = '#ffffff';
                cella.style.color = '#000000';
                cella.style.border = '1px solid #dddddd';
                cella.style.fontSize = '13px';
            });

            dati.tbodyHTML = tempTbody.innerHTML;
        } else {
            dati.tbodyHTML = '<tr><td colspan="3" style="padding: 10px; text-align: center; color: #000000;">Nessun esercizio presente</td></tr>';
        }
    }

    return dati;
}

function generaHtmlPdf() {
    // 1. Chiede al servizio di capire in quale modalità si trova la pagina ora
    const { nomeCompletoAtleta, header, nomeCoach, tbodyHTML } = estraiDatiSorgente();
    
    const dataOggi = new Date().toLocaleDateString('it-IT');
    const urlLogo = "data:image/png;base64,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" 
    

    const reportStampa = document.createElement('div');
    reportStampa.id = 'report-stampa-pdf';

    reportStampa.innerHTML = `
    <div style="font-family: Arial, sans-serif; color: #000000; padding: 20px; background-color: #ffffff;">
        <div style="width: 100%; background-color: #ffffff;">  
            <img src="${urlLogo}" alt="AleamiRunningCoach" style="display: block; margin: 0 auto; max-height: 100px; width: auto;">
        </div>
        
        <div style="border-bottom: 2px solid #000000; padding-bottom: 10px; margin-top: 20px; margin-bottom: 20px; text-align: center;">
            <h2 style="margin: 0; color: #000000; font-size: 20px; font-weight: bold; text-transform: uppercase; letter-spacing: 0.5px;">
                ${header}
            </h2>
        </div>

        <table style="width: 100%; margin-bottom: 30px; font-size: 14px; border-collapse: collapse;">
            <tr>
                <td style="padding: 5px 0;"><strong>Atleta:</strong> <span class="text-uppercase">${nomeCompletoAtleta}</span></td>
                <td style="text-align: right; padding: 5px 0;"><strong>Data Generazione:</strong> ${dataOggi}</td>
            </tr>
        </table>

        <h3 style="font-size: 16px; margin-bottom: 10px; text-transform: uppercase;">Programma Esercizi</h3>
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px; font-size: 14px;">
            <thead>
                <tr style="background-color: #f2f2f2; border-bottom: 2px solid #dddddd;">
                    <th style="padding: 10px; text-align: left; border: 1px solid #dddddd; width: 20%;">Giorno</th>
                    <th style="padding: 10px; text-align: center; border: 1px solid #dddddd; width: 20%;">Data</th>
                    <th style="padding: 10px; text-align: left; border: 1px solid #dddddd; width: 60%;">Descrizione</th>
                </tr>
            </thead>
            <tbody>
                ${tbodyHTML}
            </tbody>
        </table>

        <div style="margin-top: 40px; border-top: 1px dashed #dddddd; padding-top: 15px;">
            <table style="width: 100%; font-size: 14px; color: #444444; margin-bottom: 20px;">
                <tr>
                    <td style="padding: 0;"><strong>Coach:</strong> ${nomeCoach}</td>
                    <td style="text-align: right; padding: 0;"><strong>Stato:</strong> Pubblicata</td>
                </tr>
            </table>
        
            <h5 style="margin: 0; text-align: center; letter-spacing: 1px; color: #000000; font-size: 14px;">
                #ILSUCCESSOCHETIMERITI
            </h5>
        </div>
    </div>`;

    const opzioni = {
        margin:       15,
        filename:     `Scheda_${nomeCompletoAtleta.trim().replace(/\s+/g, '_')}_${dataOggi.replace(/\//g, '-')}.pdf`,
        image:        { type: 'jpeg', quality: 0.98 },
        html2canvas:  { scale: 2, backgroundColor: '#ffffff' }, 
        jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait' }
    };

    html2pdf().set(opzioni).from(reportStampa).save().then(() => {
        console.log("PDF generato con successo!");
    });
}